export var CashbackOfferType;
(function (CashbackOfferType) {
    CashbackOfferType["BANK"] = "bank";
    CashbackOfferType["BANK_LOYALTY"] = "bank_loyalty";
    CashbackOfferType["AFFILIATE"] = "affiliate";
})(CashbackOfferType || (CashbackOfferType = {}));
